import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import Status from './Status';

const emptyProps = {
  case_uuid: 'azbtest_2644',
  purchase_right_away: false,
  statuses: [],
  noDataFoundMessage: 'There are no pending statuses.',
  dataReady: true,
  dispatch: null,
  lastUpdated: 1000,
  error: null,
  receipt: null,
};

const sampleStatusesProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  statuses: [
    {
      status_set_by: "Notice of Appeal",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-6704-21829",
      status: "Appeal Filed",
      docket_no: 6704,
      date_status_begin: "01/19/2010",
      time_in_status: "3192 days",
      modified: "2018-10-16 16:05:01.668187+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12608914603",
  },
  {
      time_in_status: "3172 days",
      date_status_begin: "02/08/2010",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609007573",
      modified: "2018-10-16 16:05:01.72876+00",
      status_set_by: "Notice of Appeal",
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-7018-22689",
      docket_no: 7018
  },
  {
      time_in_status: "3085 days",
      date_status_begin: "05/06/2010",
      modified: "2018-10-16 16:05:01.771315+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609358207",
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-8831-28665",
      status_set_by: "Notice of Appeal",
      docket_no: 8831
  },
  {
      date_status_begin: "05/27/2010",
      time_in_status: "3064 days",
      modified: "2018-10-16 16:05:01.815288+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609440650",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9312-30085",
      status: "Appeal Filed",
      status_set_by: "Notice of Appeal",
      docket_no: 9312
  },
  {
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9313-30091",
      status: "Appeal Filed",
      status_set_by: "Notice of Appeal",
      docket_no: 9313,
      date_status_begin: "05/27/2010",
      time_in_status: "3064 days",
      modified: "2018-10-16 16:05:01.886628+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609440761"
  },
  {
      modified: "2018-10-16 16:05:01.951911+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609469459",
      date_status_begin: "06/02/2010",
      time_in_status: "3058 days",
      docket_no: 9372,
      status_set_by: "Notice of Appeal",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9372-30263",
      status: "Appeal Filed"
  },
  {
      docket_no: 9374,
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-9374-30279",
      status_set_by: "Notice of Appeal",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12609469651",
      modified: "2018-10-16 16:05:02.010515+00",
      time_in_status: "3058 days",
      date_status_begin: "06/02/2010"
  },
  {
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-12876-41052",
      status: "Appeal Filed",
      status_set_by: "Notice of Appeal",
      docket_no: 12876,
      time_in_status: "2891 days",
      date_status_begin: "11/16/2010",
      modified: "2018-10-16 16:05:02.061365+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126010146315"
  },
  {
      time_in_status: "2770 days",
      date_status_begin: "03/17/2011",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126010610871",
      modified: "2018-10-16 16:05:02.136418+00",
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-15132-47594",
      status_set_by: "Notice of Appeal",
      docket_no: 15132
  },
  {
      status_set_by: "Notice of Appeal",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18676-58545",
      status: "Appeal Filed",
      docket_no: 18676,
      time_in_status: "2645 days",
      date_status_begin: "07/20/2011",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011115084",
      modified: "2018-10-16 16:05:02.190055+00"
  },
  {
      modified: "2018-10-16 16:05:02.258715+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011149281",
      date_status_begin: "07/28/2011",
      time_in_status: "2637 days",
      docket_no: 18844,
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18844-59009",
      status: "Appeal Filed",
      status_set_by: "Notice of Appeal"
  },
  {
      docket_no: 18849,
      status_set_by: "Notice of Appeal",
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-18849-59023",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126011150054",
      modified: "2018-10-16 16:05:02.349246+00",
      date_status_begin: "07/28/2011",
      time_in_status: "2637 days"
  },
  {
      modified: "2018-10-16 16:05:02.429267+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126014729417",
      time_in_status: "1567 days",
      date_status_begin: "07/02/2014",
      docket_no: 44952,
      status: "Appeal Filed",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-44952-152348",
      status_set_by: "Notice of Appeal"
  },
  {
      docket_no: 46214,
      status_set_by: "Notice of Appeal",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-46214-158402",
      status: "Appeal Filed",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126014898943",
      modified: "2018-10-16 16:05:02.45626+00",
      date_status_begin: "09/03/2014",
      time_in_status: "1504 days"
  },
  {
      modified: "2018-10-16 16:05:02.498813+00",
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/126015105720",
      date_status_begin: "11/21/2014",
      time_in_status: "1425 days",
      docket_no: 47003,
      status_set_by: "Notice of Appeal",
      docket_related_uri: "https://ecf.nysb.uscourts.gov/cgi-bin/StatusQry.pl?603233689723074-L_ShowDktAndRelated_1-0-171257-47003-162152",
      status: "Appeal Filed"
  }
  ],
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
  type: 'status_pending',
  sidebarData: {},
  kloudless: {},
};

storiesOf('Case Menu/Status', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr />
      <Status />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a list of pending statuses received form the API</h3>
      <hr />
      <h4>Page contains 'Find What' input that searches through table of data.</h4>
      <h4>There is 'Premium Search' button, which leads to the premium search url.</h4>
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <Status
        {...sampleStatusesProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))

  .add('No Data', () => (
    <div>
      <h3>If there is no data found, message is displayed.</h3>
      <hr />
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <Status {...emptyProps} />
    </div>
  ));




// WEBPACK FOOTER //
// ./src/components/case/status/Status.stories.jsx